"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/karjala/karjala.scss');
const index_1 = require("./../js/index");
const karjala_1 = require("./../js/Sites/karjala");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize Mattsson specific scripts
(0, karjala_1.InitKarjala)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)();
